import { BaseIconButton } from '@/components';
import { BaseCard } from '@/components/uiKit/Cards';
import { Skeleton } from '@/components/ui/skeleton';
import { useFetchResource } from '@/hooks/shared';
import React from 'react';
import CardTitle from '@/components/uiKit/Cards/CardTitle';
import { useActiveAssetsType } from '@/hooks/shared/useActiveAssetsType';
import { Icon } from '@/components/shared/display/Icon';
import { ExpandIcon, NoImageIcon } from '@/assets/Icons';

interface AssetImageProps {
  asset: any;
  isLoading: boolean;
}

export const AssetImage = ({ asset, isLoading }: AssetImageProps) => {
  const { isMobileAsset } = useActiveAssetsType();
  const imageTitle = isMobileAsset ? `${asset?.asset_type || 'Asset'}` : `${asset?.asset_ui_name || 'Asset'}`;
  const { resource: imageURL, isLoadingResource, isError, retry } = useFetchResource(asset?.asset_image_resource_id);
  return isLoadingResource || isLoading ? (
    <Skeleton className="h-[calc(100%+30px)]" />
  ) : (
    <BaseCard
      variant="wrapper"
      classNames={{
        card: 'h-full flex flex-col',
        content: `flex flex-1 px-0 bg-transparent py-0 ${imageURL ? '' : 'bg-white'}`,
      }}
      title={<CardTitle text={imageTitle || ''} />}
    >
      {imageURL ? (
        <div className="flex items-center flex-1 relative group overflow-hidden pt-1">
          <img src={imageURL} className="absolute w-full h-100 rounded-xl" alt="Asset" />
          <BaseIconButton
            dialog={{
              className: 'w-fit',
              title: imageTitle,
              element: (
                <img
                  src={imageURL}
                  className="max-h-[80vh] w-100 object-cover" // Stretch in the dialog
                  alt="Asset Expanded"
                />
              ),
            }}
            icon={ExpandIcon}
            variant="ghost"
            classNames={{
              icon: '!scale-[2.2] rounded-full bg-[#fff]',
              button: 'absolute right-1 bottom-1 rounded-full',
            }}
          />
        </div>
      ) : isError ? (
        <div className="h-full w-full flex items-center justify-center flex-col text-sm gap-1">
          <Icon icon={NoImageIcon} className="w-16 h-16" />
          <span>Failed to load image</span>
          <button onClick={retry} className="text-primary-600 hover:underline text-xs">Try Again</button>
        </div>
      ) : (
        <div className="h-full w-full flex items-center justify-center flex-col text-sm">
          <Icon icon={NoImageIcon} className="w-16 h-16" />
          No Image
        </div>
      )}
    </BaseCard>
  );
};
